/*
 * @see [Documentation](https://nuxt-graphql-middleware.dulnan.net/advanced/templates#operation-hashes)
 */
export const operationHashes = {
  "adminToolbar": "_R2mbdxOJd",
  "businessAreas": "Zq1elegAWR",
  "drupalUser": "sNc-Q0VM7u",
  "initData": "1ZKog-7K9q",
  "loadTranslations": "4GjPNx6T1A",
  "localTasks": "4KpYWXogBj",
  "newsList": "MsltMOxXAM",
  "newsTeaserList": "qzIAb85rK4",
  "pbAddClipboardText": "JlzaqDi60T",
  "pbAddComment": "ndl0-MmxVg",
  "pbAddEntityReference": "MW0zZwjeDX",
  "pbAddEntityReferenceMultiple": "H7uDUjZNit",
  "pbAddFile": "mgcFPj6_fu",
  "pbAddFragmentParagraph": "zkNSbiQoFb",
  "pbAddImage": "trHKILC19O",
  "pbAddParagraph": "duBnF6niOp",
  "pbAddReusableParagraph": "K39LBjvE1o",
  "pbAddVideoRemote": "nLbZM7xfeH",
  "pbApplyTransformPlugin": "fyfo4CGvGb",
  "pbBulkUpdateParagraphBehaviorSettings": "t8XXy4SfJM",
  "pbComments": "eLhHrN5PPt",
  "pbConfig": "S8qpiEegF_",
  "pbConversions": "hIb-h-hpru",
  "pbConvertMultiple": "jMmPsWtC-w",
  "pbConvertParagraph": "GGA1RmH60v",
  "pbCopyFromExisting": "s8l3698sLb",
  "pbDeleteMultipleParagraphs": "VmGzCzp98p",
  "pbDeleteParagraph": "8d72EAEIDZ",
  "pbDetachReusableParagraph": "bNshzBASbx",
  "pbDuplicateMultipleParagraphs": "C5Nzz7oH2U",
  "pbDuplicateParagraph": "6MHHcvveF0",
  "pbEditState": "DiDoTjiyut",
  "pbGetImportSourceEntities": "va6PnAMoeJ",
  "pbGetPreviewGrantUrl": "sAJOzxHeUi",
  "pbGetTransformPlugins": "qa4M4JfbbI",
  "pbLibraryItems": "U6H-ktmSaw",
  "pbMakeParagraphReusable": "CEdgP3EqGk",
  "pbMediaLibraryGetResults": "gA3YxwjAUh",
  "pbMoveMultipleItems": "voehWr4WDX",
  "pbMoveParagraph": "94ZPXhAVTe",
  "pbPublish": "SAjnuxHZqO",
  "pbRedo": "mYx1-P_q_g",
  "pbReplaceHostEntityMedia": "9v8mber_Iy",
  "pbReplaceMedia": "HuvAtdt9Lt",
  "pbResolveComment": "gAt359uTiN",
  "pbRevertAllChanges": "npAQLAk1CD",
  "pbSearch": "gZi3jFPAyy",
  "pbSearchTabs": "3jxTsFlHH7",
  "pbSetHistoryIndex": "o6qoJJ6fPp",
  "pbSetMutationItemStatus": "oN_LI1l_je",
  "pbTakeOwnership": "C51o7WRjbo",
  "pbUndo": "oA0c-oVP9G",
  "pbUpdateFieldValue": "d-DAr6SHIB",
  "pbUpdateHostEntityFieldValue": "wgoThP09Ke",
  "pbUpdateParagraphOption": "mDFqS9kL2l",
  "routeNodeCanonical": "WPvdIaiTzW",
  "routeNodePage": "DUR_jjzbDJ",
  "routeNodePressRelease": "1skKOQ28C2",
  "routeSlug": "HCn28TCiHj",
  "routeWebform": "BLg2AIr6uJ",
  "search": "0dvHttaVOk",
  "submitWebform": "TgnEpmhTJP",
  "webformConfirmation": "GCKVdyHElr"
}